import { Pipe, PipeTransform } from '@angular/core';
import { Status } from '../interfaces/status.interface';
import { StatusDesc } from '../interfaces/status-desc.interface';

@Pipe({
  name: 'toStatusDesc',
  standalone: true,
})
export class ToStatusDescPipe implements PipeTransform {
  transform(value: Status): StatusDesc {
    return StatusDesc[Status[value]];
  }
}
